/**
 * Central filter system used by ScopeTable.
 * Apply logic lives here so filter behavior is consistent and easy to maintain.
 */

export { applyFilters } from './applyPipeline';
export { useClientFilterPipeline } from './useClientFilterPipeline';
export type { FilterState, FilterApplyOptions, FilterOptionExtractorOptions } from './types';
